import { Link } from '../../atoms/link/Link';
import styles from './ContentGrid.module.scss';
import { ResponsiveImage } from '../../atoms/image/ResponsiveImage';
import clsx from 'clsx';
import React from 'react';
import VideoPlayer from '../../atoms/VideoPlayer';

export const ContentGrid = ({ data, type, isLinkCovered }) => {
  const {
    colNumberDesktop,
    colNumberTablet,
    colNumberMobile,
    colGapDesktop,
    colGapTablet,
    colGapMobile,
    imageblock,
    contentblock,
    desktop,
    mobile,
    tablet,
  } = data;

  const renderMedia = (image) => (
    <div className={styles.image}>
      {image.media.resourceType === 'video' ? (
        <VideoPlayer
          url={image.media.file}
          aspectRatio={image?.ratio?.replace(':', '/')}
          style={{
            display: 'flex',
          }}
        />
      ) : (
        <ResponsiveImage source={image} />
      )}
    </div>
  );

  return (
    <div
      style={{
        '--col-number-desktop': colNumberDesktop || 2,
        '--col-number-tablet': colNumberTablet || 2,
        '--col-number-mobile': colNumberMobile || 1,
        '--col-gap-desktop': colGapDesktop ? colGapDesktop + 'px' : 0,
        '--col-gap-tablet': colGapTablet ? colGapTablet + 'px' : 0,
        '--col-gap-mobile': colGapMobile ? colGapMobile + 'px' : 0,
      }}
      className={clsx(styles.root, styles[`type_${type}`], {
        [styles.mobileVisibility]: mobile,
        [styles.tabletVisibility]: tablet,
        [styles.desktopVisibility]: desktop,
      })}
    >
      {type === 'media' &&
        imageblock &&
        imageblock.map((item, index) => {
          const {
            alignment = 'left',
            image,
            linkTitle,
            position = 'under',
            reference,
            text,
          } = item;
          return (
            <div
              key={index}
              className={clsx(
                styles.imageBlock,
                styles[`position_${position}`],
              )}
            >
              {isLinkCovered && reference ? (
                <Link link={{ reference: reference }}>
                  {renderMedia(image)}
                </Link>
              ) : (
                renderMedia(image)
              )}
              <div
                className={clsx(
                  styles.content,
                  styles[`alignment_${alignment}`],
                )}
              >
                {text && <span>{text}</span>}
                {linkTitle && (
                  <Link className={styles.textLink} link={{ reference: reference }}>
                    <span>{linkTitle}</span>
                  </Link>
                )}
              </div>
            </div>
          );
        })}
      {type === 'text' &&
        contentblock &&
        contentblock.map((item, index) => {
          const {
            horizontalPosition = 'left',
            titleAlignment = 'left',
            verticalPosition = 'top',
            text,
          } = item;
          return (
            <div
              key={index}
              className={clsx(
                styles.contentBox,
                styles[`v_position_${verticalPosition}`],
                styles[`h_position_${horizontalPosition}`],
                styles[`text_align_${titleAlignment}`],
              )}
              dangerouslySetInnerHTML={{ __html: text }}
            />
          );
        })}
    </div>
  );
};
